/*
 * @Author: zhangsheng
 * @Date: 2023-08-21 09:51:52
 * @LastEditors: zhangsheng
 * @LastEditTime: 2023-09-21 08:52:02
 * @FilePath: \panda-index-sicermem-frontend\src\pc\index.tsx
 * @Description:
 *
 * Copyright (c) 2023 by zhangsheng , All Rights Reserved.
 */
import React from 'react';
import { BrowserRouter as Router, useRoutes } from 'react-router-dom';

import { ConfigProvider } from 'antd';
import zhCN from 'antd/lib/locale/zh_CN';
import enUS from 'antd/lib/locale/en_US';

import pcRouter from './router';
import { useTranslation } from 'react-i18next';


const AppRoutes = () => useRoutes(pcRouter);
const App: React.FC = () => {
  const { i18n } = useTranslation();

  return (
    <ConfigProvider locale={i18n.language == 'zh' ? zhCN : enUS} getPopupContainer={(node) => document.body}>
      <Router>
        <AppRoutes />
      </Router>
    </ConfigProvider>
  );
};
export default App;
